import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  tokenExpiry: string | null;
  loading: boolean;
  roles: string[];
  supplierOrganisations: any[];
  depots: any[];
  authenticated: boolean;
  error: any;
  activeIdentifier: any;
}

const initialAuthState: AuthState = {
  tokenExpiry: null,
  loading: false,
  roles: [],
  supplierOrganisations: [],
  depots: [],
  authenticated: false,
  error: null,
  activeIdentifier: null
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialAuthState,
  reducers: {
    loginLoading: (state) => {
      return {
        ...state,
        ...initialAuthState,
        loading: true
      };
    },
    loginSuccess: (state, action: PayloadAction<any>) => {
      const ssoTokenExpiry = action.payload.expires_at;
      window.localStorage.setItem("accessToken", action.payload.access_token);
      window.localStorage.setItem("refreshToken", action.payload.refresh_token);
      window.localStorage.setItem("expiry", ssoTokenExpiry);
      window.localStorage.setItem("Id", action.payload.profile.id);
      
      let identifier;
      return {
        ...state,
        ...initialAuthState,
        authenticated: true,
        loading: false,
        tokenExpiry: ssoTokenExpiry,
        activeIdentifier: identifier
      };
    },
    loginError: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        ...initialAuthState,
        error: action.payload
      };
    },
    apiError: (state, action: PayloadAction<any>) => {
      return {
        ...initialAuthState,
        error: action.payload
      };
    }
  }
});

export const {
  loginLoading,
  loginSuccess,
  loginError,
  apiError
} = authSlice.actions;

export default authSlice.reducer;
